/* Mike's Liquors — Demand signals v1 (2026-10-23). Live theme asset: assets/mikes-demand.js.
   Repo copy: shopify-dev/demand-signals/theme/mikes-demand.js (copy the live asset back here after
   any change). Tom: "know when customers are trying to order more kegs than we have available".

   Tells the mikes-demand collector (shopify-dev/demand-signals/collector) about two moments:
     short    a cart call asked for more of a product than Shopify would give ("Only 3 items were
              added to your cart due to availability"): product page, cart page or drawer, EN or ES.
     soldout  a product page is showing a sold-out size (each size at most once a day per browser).
   Victoria's morning job (voice-agent/demand-report/ on the victoria-cloud-migration branch) turns
   them into a Slack summary in #orders-inbox.

   LOAD ORDER MATTERS. layout/theme.liquid includes this file BEFORE mikes-deposits.js. That script
   captures window.fetch when it loads, so wrapping first puts this wrapper UNDER it, where it sees
   the real network calls. On a keg "+" the deposit script answers Shopify's 422 with its own 200
   (v3.34), so a wrapper above it would never see the shortfall.

   It must never change what a cart call does: the caller gets the very same Response (this reads a
   clone), every step is in try/catch, and a down collector only loses the beacon. Browsers driven
   by automation are ignored unless the tab was opened with ?mikes_demand_test=1, and those events
   are marked test so the report skips them. */
(function mikesDemand() {
  'use strict';
  var CFG = window.MIKES_DEMAND;
  if (!CFG || !CFG.url || typeof window.fetch !== 'function') return;
  if (window.Shopify && window.Shopify.designMode) return;

  function noop() {}
  function num(x) {
    var n = parseInt(x, 10);
    return isNaN(n) ? null : n;
  }
  function storageGet(kind, key) {
    try { return window[kind].getItem(key); } catch (e) { return null; }
  }
  function storageSet(kind, key, value) {
    try { window[kind].setItem(key, value); } catch (e) { /* private mode: fine */ }
  }

  if (/[?&]mikes_demand_test=1(&|$)/.test(location.search)) storageSet('sessionStorage', 'mikes_demand_test', '1');
  var TEST = storageGet('sessionStorage', 'mikes_demand_test') === '1';
  var ua = (navigator && navigator.userAgent) || '';
  if (!TEST && ((navigator && navigator.webdriver) || /bot|crawl|spider|headless|lighthouse/i.test(ua))) return;

  var SID = storageGet('sessionStorage', 'mikes_demand_sid');
  if (!SID || !/^[A-Za-z0-9]{6,40}$/.test(SID)) {
    SID = Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
    storageSet('sessionStorage', 'mikes_demand_sid', SID);
  }

  var _fetch = window.fetch.bind(window);
  var snap = null;   // the last cart seen: { byVariant: {variantId: qty}, token }
  var sent = {};     // short events sent in the last minute, so rapid taps count once

  function send(ev) {
    try {
      ev.s = SID;
      if (CFG.cid) ev.cid = CFG.cid;
      ev.path = String(location.pathname || '').slice(0, 200);
      var lang = document.documentElement && document.documentElement.lang;
      if (lang) ev.lang = String(lang).slice(0, 8);
      if (TEST) ev.test = 1;
      var body = JSON.stringify(ev);
      if (navigator.sendBeacon) {
        try {
          if (navigator.sendBeacon(CFG.url, new Blob([body], { type: 'text/plain' }))) return;
        } catch (e) { /* fall through to fetch */ }
      }
      // sendBeacon says no when the browser's beacon queue is full (Shopify's own tracking sends
      // big beacons on every add). keepalive shares that queue, so the fallback is a plain request.
      _fetch(CFG.url, {
        method: 'POST', body: body, mode: 'no-cors', credentials: 'omit',
        headers: { 'Content-Type': 'text/plain' }
      }).catch(noop);
    } catch (e) { /* never let reporting break the page */ }
  }

  function cartToken(cart) {
    var t = (cart && cart.token) || (snap && snap.token) || '';
    if (!t) {
      var m = /(?:^|;\s*)cart=([^;]+)/.exec(document.cookie || '');
      if (m) { try { t = decodeURIComponent(m[1]); } catch (e) { t = ''; } }
    }
    t = String(t).split('?')[0];
    return /^[A-Za-z0-9_-]{6,64}$/.test(t) ? t : undefined;
  }

  function remember(cart) {
    if (!cart || !cart.items || !cart.items.forEach) return;
    var by = {};
    cart.items.forEach(function (l) { by[l.variant_id] = (by[l.variant_id] || 0) + l.quantity; });
    snap = { byVariant: by, token: cart.token };
  }

  // '/cart.js' -> 'cart'; '/cart/add', '/cart/change', '/cart/update' (.js or not, /es/ too) -> that.
  function cartKind(url) {
    var path;
    try { path = new URL(url, location.href).pathname; } catch (e) { return null; }
    if (/\/cart\.js$/.test(path)) return 'cart';
    var m = /\/cart\/(add|change|update)(\.js)?$/.exec(path);
    return m ? m[1] : null;
  }

  function fromParams(p) {
    var o = {};
    p.forEach(function (value, key) {
      var u = /^updates\[(.*)\]$/.exec(key);
      if (u) {
        o.updates = o.updates || (u[1] === '' ? [] : {});
        if (Array.isArray(o.updates)) o.updates.push(value);
        else o.updates[u[1]] = value;
      } else if (key === 'id' || key === 'quantity' || key === 'line') {
        o[key] = value;
      }
    });
    return o;
  }

  function bodyOf(init) {
    var b = init && init.body;
    if (b == null) return null;
    if (typeof b === 'string') {
      try { return JSON.parse(b); } catch (e) { /* not JSON */ }
      try { return fromParams(new URLSearchParams(b)); } catch (e) { return null; }
    }
    if (typeof FormData !== 'undefined' && b instanceof FormData) return fromParams(b);
    if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return fromParams(b);
    return null;
  }

  // What the call asked the cart to hold afterwards, one target per line or variant.
  function targetsFor(kind, body) {
    var out = [];
    if (kind === 'add') {
      var items = body.items || (body.id != null ? [{ id: body.id, quantity: body.quantity }] : []);
      var added = {};
      items.forEach(function (it) {
        var v = num(it && it.id);
        var q = it && it.quantity != null ? num(it.quantity) : 1;
        if (v && q > 0) added[v] = (added[v] || 0) + q;
      });
      Object.keys(added).forEach(function (v) {
        var prev = snap ? (snap.byVariant[v] || 0) : null;
        out.push({ v: +v, q: (prev || 0) + added[v], exact: prev !== null });
      });
    } else if (kind === 'change') {
      var q = num(body.quantity);
      if (q == null) return out;
      if (body.line != null) out.push({ line: num(body.line), q: q, exact: true });
      else if (body.id != null && String(body.id).indexOf(':') > 0) {
        out.push({ key: String(body.id), v: num(String(body.id).split(':')[0]), q: q, exact: true });
      } else if (body.id != null) out.push({ v: num(body.id), q: q, exact: true });
    } else if (kind === 'update') {
      var u = body.updates;
      if (Array.isArray(u)) {
        u.forEach(function (val, i) { var n = num(val); if (n != null) out.push({ line: i + 1, q: n, exact: true }); });
      } else if (u && typeof u === 'object') {
        Object.keys(u).forEach(function (k) {
          var n = num(u[k]);
          if (n == null) return;
          if (k.indexOf(':') > 0) out.push({ key: k, v: num(k.split(':')[0]), q: n, exact: true });
          else out.push({ v: num(k), q: n, exact: true });
        });
      }
    }
    return out.filter(function (t) { return (t.v || t.line || t.key) && t.q > 0; });
  }

  function isDeposit(line) {
    return /-DEP\b/i.test(line.sku || '') || /deposit/i.test(line.product_type || '');
  }

  // Compare what was asked for with the cart Shopify ended up with; report each shortfall.
  function report(kind, targets, cart, msg) {
    var lines = (cart && cart.items) || [];
    var token = cartToken(cart);
    targets.forEach(function (t) {
      var target = null;
      if (t.key) {
        for (var i = 0; i < lines.length; i++) if (lines[i].key === t.key) { target = lines[i]; break; }
      } else if (t.line) {
        target = lines[t.line - 1] || null;
        if (!target) return;
      }
      var v = target ? target.variant_id : t.v;
      if (!v) return;
      var total = 0, other = 0, pid, deposit = false;
      lines.forEach(function (l) {
        if (l.variant_id !== v) return;
        total += l.quantity;
        if (l !== target) other += l.quantity;
        pid = l.product_id;
        if (isDeposit(l)) deposit = true;
      });
      if (deposit) return;
      var wanted = (t.key || t.line) ? other + t.q : t.q;
      // An add that failed with no earlier cart to compare: they wanted at least one more.
      if (kind === 'add' && !t.exact && msg != null) wanted = Math.max(wanted, total + 1);
      if (!(wanted > total)) return;
      var seen = v + ':' + wanted + ':' + total;
      var now = Date.now();
      if (sent[seen] && now - sent[seen] < 60000) return;
      sent[seen] = now;
      var ev = { t: 'short', v: v, w: wanted, g: total, wx: t.exact ? 1 : 0, src: kind };
      if (pid) ev.pid = pid;
      if (msg) ev.msg = String(msg).slice(0, 160);
      if (token) ev.ct = token;
      send(ev);
    });
  }

  function settle(kind, targets, response) {
    response.clone().text().then(function (text) {
      var data = null;
      try { data = JSON.parse(text); } catch (e) { /* not JSON */ }
      var failed = !response.ok || !!(data && data.errors);
      if (!failed) {
        // change/update answer with the whole cart: check it too (a silent cap shows up here).
        if (data && data.items && typeof data.item_count === 'number') {
          remember(data);
          report(kind, targets, data, null);
        }
        return;
      }
      var msg = (data && (data.description || data.message || data.errors)) || '';
      if (typeof msg !== 'string') { try { msg = JSON.stringify(msg); } catch (e) { msg = ''; } }
      // A 422 can still have changed the cart (a partial add): read what it holds now.
      _fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { remember(cart); report(kind, targets, cart, msg); }, noop);
    }, noop);
  }

  function watch(resource, init, promise) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || String(resource || '');
    var kind = cartKind(url);
    if (!kind) return;
    var method = String((init && init.method) || (resource && resource.method) || 'GET').toUpperCase();
    if (kind === 'cart') {
      if (method === 'GET') {
        promise.then(function (r) {
          if (r && r.ok) r.clone().json().then(remember, noop);
        }, noop);
      }
      return;
    }
    if (method !== 'POST') return;
    var body = bodyOf(init);
    if (!body) return;
    var targets = targetsFor(kind, body);
    if (!targets.length) return;
    promise.then(function (r) {
      try { if (r) settle(kind, targets, r); } catch (e) { /* ignore */ }
    }, noop);
  }

  window.fetch = function (resource, init) {
    var promise = _fetch(resource, init);
    try { watch(resource, init, promise); } catch (e) { /* the call itself is untouched */ }
    return promise;
  };

  // ── Sold-out views (product pages only) ─────────────────────────────
  var P = CFG.product;
  if (!P || P.hidden) return;

  function soldOut(variantId) {
    variantId = num(variantId);
    if (!variantId) return;
    var day = new Date().toDateString();
    var seen = null;
    try { seen = JSON.parse(storageGet('localStorage', 'mikes_demand_so') || 'null'); } catch (e) { seen = null; }
    if (!seen || seen.d !== day || !Array.isArray(seen.v)) seen = { d: day, v: [] };
    if (seen.v.indexOf(variantId) !== -1) return;
    seen.v.push(variantId);
    if (seen.v.length > 200) seen.v = seen.v.slice(-200);
    storageSet('localStorage', 'mikes_demand_so', JSON.stringify(seen));
    send({ t: 'soldout', v: variantId, pid: P.id });
  }

  try {
    if (P.avail && P.avail[P.sel] === false) soldOut(P.sel);
  } catch (e) { /* ignore */ }

  // Picking a sold-out size on the page. Quick-add windows for OTHER products fire this event
  // too; only this page's own product counts.
  document.addEventListener('variant:update', function (event) {
    try {
      var d = event.detail || {};
      var r = d.resource;
      if (!r || r.available !== false) return;
      var pid = d.data && d.data.productId;
      if (pid && String(pid) !== String(P.id)) return;
      soldOut(r.id);
    } catch (e) { /* ignore */ }
  });
})();
